import React from 'react';
import './ContactPage.css';
import Aurora from '../components/Aurora';
import '../components/Aurora.css';
import ShinyText from '../components/ShinyText';
import ScrollFloat from '../components/ScrollFloat';

const ContactPage = () => {
  return (
    <div className="aurora-container">
            { <Aurora
                colorStops={["#3A29FF", "#ACADBC", "#006A52"]}
                blend={0.5}
                amplitude={1.0}
                speed={0.5}
                />  }
    <div className="contact-container">
      <div className="contact-content">
        {/* Header Section */}
        <div className="section-heading">
          <ScrollFloat
            animationDuration={1}
            ease='back.inOut(2)'
            scrollStart='center bottom+=20%'
            scrollEnd='bottom bottom-=40%'
            stagger={0.03}
          >
            Contact Us
          </ScrollFloat>
          <p>Get in touch with the <ShinyText text="Bendall Laboratory" speed={3} /> team</p>
        </div>

        {/* Separator */}
        <div className="section-separator" style={{
          width: '100%',
          height: '1px',
          background: 'var(--section-border)',
          margin: '40px 0 40px 0'
        }}></div>

        {/* Contact Information */}
        <div className="contact-section">
          <h3>Contacts</h3>
          <div className="contact-card">
            <div className="contact-grid-inner">
              <div className="contact-item">
                <h4>Laboratory Director</h4>
                <p><strong>Dr. John Doe</strong></p>
                <p>Professor of Pathology</p>
                <p>Email: <a href="mailto:jdoe@stanford.edu">jdoe@stanford.edu</a></p>
                <p>Phone: (123) 456-7890</p>
              </div>

              <div className="contact-item">
                <h4>Laboratory Manager</h4>
                <p><strong>Jane Doe</strong></p>
                <p>Email: <a href="mailto:janedoe@stanford.edu">janedoe@stanford.edu</a></p>
                <p>Phone: (123) 456-7891</p>
              </div>

              <div className="contact-item">
                <h4>Administrative Assistant</h4>
                <p><strong>John Doe</strong></p>
                <p>Email: <a href="mailto:johndoe@stanford.edu">johndoe@stanford.edu</a></p>
                <p>Phone: (123) 456-7892</p>
              </div>

              <div className="contact-item">
                <h4>Mailing Address</h4>
                <p>Bendall Laboratory<br/>
                Stanford University School of Medicine<br/>
                300 Pasteur Drive, Room L235<br/>
                Stanford, CA 94305-5324</p>
              </div>
            </div>
          </div>
        </div>

        {/* Location Section */}
        <div className="location-section">
          <h3>Location</h3>
          <div className="location-content">
            <div className="location-info">
              <h4>Bendall Laboratory</h4>
              <p>Stanford University School of Medicine<br/>
              300 Pasteur Drive, Room L235<br/>
              Stanford, CA 94305-5324</p>

              <div className="directions">
                <h5>Directions</h5>
                <p>The laboratory is located in the <ShinyText text="Edwards Research Building" speed={3} /> on the Stanford University campus. Visitor parking is available in nearby structures.</p>
                
                <h5>Public Transportation</h5>
                <p>Caltrain: Stanford Station (free shuttle to campus)<br/>
                VTA Bus: Routes 22 and 522 serve Stanford campus</p>
              </div>
            </div>
            
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1332.0604608123335!2d-122.17684496798995!3d37.432579327956695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fa4d31ed339d1%3A0xecb89c1d73f8e420!2sEdwards%20Research%20Building!5e0!3m2!1sru!2sus!4v1749772665126!5m2!1sru!2sus" 
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Bendall Laboratory Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ContactPage;
